var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-img',{staticClass:"site-logo",attrs:{"src":"logo.svg","height":"","alt":_vm.$store.state.site.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }